module.exports = "/static/assets/a9dd1477f22d75060a8c3ef1fa06b3eb.png";